import React from 'react';
import { ResultLayout } from './ResultLayout';

export function ResultPage({
  language = 'German language learning',
  courseType = 'Course Practice',
  level = 'All Levels',
  subcourseName = null,
  lessonName = null,
  practiceTypeLabel = null,
  subPracticeTypeLabel = null,
  subpracticeTypeLabel = null,
  currentLevel = 2,
  previousLevel = 1.8,
  deltaLevel = 0.2,
  score = 8,
  totalQuestions = 10,
  correctCount = 8,
  onBack,
  onContinue,
  onReview,
}) {
  return (
    <ResultLayout
      variant="full"
      language={language}
      courseType={courseType}
      level={level}
      subcourseName={subcourseName}
      lessonName={lessonName}
      practiceTypeLabel={practiceTypeLabel}
      subPracticeTypeLabel={subPracticeTypeLabel}
      subpracticeTypeLabel={subpracticeTypeLabel}
      currentLevel={currentLevel}
      previousLevel={previousLevel}
      deltaLevel={deltaLevel}
      score={score}
      totalQuestions={totalQuestions}
      correctCount={correctCount}
      onBack={onBack}
      onContinue={onContinue}
      onReview={onReview}
    />
  );
}

export { ResultLayout } from './ResultLayout';
export { ResultBanner } from './ResultBanner';
export { ResultActions } from './ResultActions';
export { Level } from './Level';
export { ScoreCard } from './ScoreCard';
export { ReviewButton } from './ReviewButton';
export { ContinueButton } from './ContinueButton';
export { default as XPBar } from './XPBar';
